module.exports = __webpack_public_path__ + "img/stick_nature_by_night.40bd68df.svg";